import React, { useState, useEffect } from "react";
import API from "../axios";
import "../style/attendance.css"

const Attendance = () => {
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showLegend, setShowLegend] = useState(false);
  const [filterType, setFilterType] = useState("all");

  const empDetails = JSON.parse(localStorage.getItem("empDetails") || "{}");

  const isCorporate =
  empDetails?.branchname?.toLowerCase() === "corporate";

  // ✅ Set default 26 → 25 cycle
  useEffect(() => {
    const today = new Date();

    let from, to;

    if (today.getDate() >= 26) {
      from = new Date(today.getFullYear(), today.getMonth(), 26);
      to = new Date(today.getFullYear(), today.getMonth() + 1, 25);
    } else {
      from = new Date(today.getFullYear(), today.getMonth() - 1, 26);
      to = new Date(today.getFullYear(), today.getMonth(), 25);
    }

    const formatDate = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    };

    setFromDate(formatDate(from));
    setToDate(formatDate(to));
  }, []);



  // ✅ Fetch Attendance
  const fetchAttendance = async () => {
    try {
      setLoading(true);

      const res = await API.post("/attendance", {
        fromDate,
        toDate,
        empcode: empDetails.employee_code
      });

      console.log(res.data);

      setData(res.data);
    } catch (err) {
      console.error("Error fetching attendance", err);
    } finally {
      setLoading(false);
    }
  };

  const isSecondOrFourthSaturday = (dateString) => {
  const date = new Date(dateString);

  // Check if Saturday (6)
  if (date.getDay() !== 6) return false;

  const day = date.getDate();

  // Find week number in month
  const weekNumber = Math.ceil(day / 7);

  return weekNumber === 2 || weekNumber === 4;
};

  // ✅ Auto fetch when date changes (with small delay)
  useEffect(() => {
    if (fromDate && toDate) {
      const delay = setTimeout(() => {
        fetchAttendance();
      }, 300);

      return () => clearTimeout(delay);
    }
  }, [fromDate, toDate]);

  // ✅ Calculate Counts
// const lateCount = data.filter(
//   (item) =>
//     item.pintime &&  
//     item.pintime >= "10:06:59" &&
//     item.pintime <= "10:30:59" &&
//     item.pintime !== "00:00:00" 
// ).length;

const lateCount = data.filter(
  (item) =>
     (!item.holidays || item.holidays.trim() === "") &&
    item.pintime && 
    item.pintime >= "10:06:59" &&
    item.pintime <= "10:31:59" &&    
    item.pintime !== "00:00:00" 
).length;

const evelateCount = data.filter(
  (item) =>
     (!item.holidays || item.holidays.trim() === "") &&
    item.pouttime && 
    item.pouttime > "18:29:59" &&
    item.pouttime <= "19:00:00" &&    
    item.pouttime !== "00:00:00" 
).length;

const evePermissionCount = data.filter(
  (item) =>
     (!item.holidays || item.holidays.trim() === "") &&
    item.pouttime &&
     item.pouttime >= "17:00:00" &&
    item.pouttime < "18:30:00"
).length;

const morPermissionCount = data.filter(
  (item) =>
     (!item.holidays || item.holidays.trim() === "") &&
    item.pintime &&
     item.pintime >= "10:32:00" &&
    item.pintime < "12:00:59"
).length;

const missedCount = data.filter(
  (item) =>
    
    item.pintime &&
    item.pouttime &&
    item.pintime === item.pouttime &&
    item.pintime !== "00:00:00"
).length;


const filteredData = data.filter((item) => {
  if (filterType === "all") return true;

  if (
    filterType === "leave" &&
     (!item.holidays || item.holidays.trim() === "") &&
    (!item.pintime || item.pintime === "00:00:00") &&
    (!item.pouttime || item.pouttime === "00:00:00") 
    &&
    isCorporate &&
    new Date(item.attDate).getDay() !== 0 && // Exclude Sunday
    !isSecondOrFourthSaturday(item.attDate) // Exclude 2nd & 4th Saturday
  ) {
    return true;
  }

  if (
    filterType === "late" &&
         (!item.holidays || item.holidays.trim() === "") &&
    (
      (item.pintime >= "10:06:59" &&
        item.pintime <= "10:31:59") ||
      (item.pouttime > "18:29:59" &&
        item.pouttime <= "19:00:00")
    )
  ) {
    return true;
  }

  if (
    filterType === "permission" &&
        (!item.holidays || item.holidays.trim() === "") &&
    (
      
      (item.pintime >= "10:32:00" &&
        item.pintime < "12:00:00") ||
      (item.pouttime >= "17:00:00" &&
        item.pouttime < "18:30:00")
    )
  ) {
    return true;
  }

  if (
    filterType === "missed" &&
        (!item.holidays || item.holidays.trim() === "") &&
    item.pintime === item.pouttime &&
    item.pintime !== "00:00:00"
  ) {
    return true;
  }

  return false;
});


  return (
    <div className="container mt-3 pt-lg-5 mt-lg-2">


      <h3 className="mb-lg-3 mb-4 titlepage">Attendance</h3>

         {/* FILTER */}
      <div className="row mb-lg-3 mb-2 filter-box ">
        
            <div className="col-6 col-md-2">
                <input
                type="date"
                className="form-control"
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
                />
            </div>

            <div className="col-6 col-md-2">
                <input
                type="date"
                className="form-control"
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
                />
            </div>

      </div>

{
empDetails.branchname == 'CORPORATE' && 
            <div className="attendance-filters mt-lg-3 mt-2 mb-lg-3 mb-1 d-flex">
                  <button
                    className={`btn btn-sm all-btn  ${
                              filterType === "all" ? "active-filter" : ""
                            }  `}
                    onClick={() => setFilterType("all")}
                  >
                    All
                  </button>

                  <button
                    className={`btn btn-sm  leave-btn  ${
                          filterType === "leave" ? "active-filter" : ""
                        }`}
                    onClick={() => setFilterType("leave")}
                  >
                    Not Available
                  </button>

                  <button
                    className={`btn btn-sm  late-btn ${
                          filterType === "late" ? "active-filter" : ""
                        }`}
                    onClick={() => setFilterType("late")}
                  >
                    Late
                  </button>

                  <button
                    className={`btn btn-sm  permission-btn ${
                          filterType === "permission" ? "active-filter" : ""
                        }`}
                    onClick={() => setFilterType("permission")}
                  >
                    Permission
                  </button>

                  <button
                    className={`btn btn-sm missed-btn ${
                          filterType === "missed" ? "active-filter" : ""
                        }`}
                    onClick={() => setFilterType("missed")}
                  >
                    Missed 
                  </button>
                </div>
}

{
empDetails.branchname == 'CORPORATE' && 


 <div className="row bg-light my-1 pt-2 rounded">
  

  <div className="col-3 col-lg-3">
    <div className="attendance-card late-card text-center"> 
      <h6>Late Count</h6>
      <h5 className="">{lateCount+evelateCount}</h5>
    </div>
  </div>

  <div className="col-3 col-lg-3">
    <div className="attendance-card permission-card text-center">
      <h6>Permit</h6>
      <h5 className="">{evePermissionCount + morPermissionCount}</h5>
    </div>
  </div>

  {/* <div className="col-3 col-lg-3">
    <div className="attendance-card permission-card text-center">
      <h6>Morning Permit</h6>
      <h5 className="">{morPermissionCount}</h5>
    </div>
  </div>

  <div className="col-3 col-lg-3">
    <div className="attendance-card permission-card text-center">
      <h6>Evening Permit</h6>
      <h5 className="">{evePermissionCount}</h5>
    </div>
  </div> */}

  <div className="col-3 col-lg-3">
    <div className="attendance-card missed-card text-center">
      <h6>Missed Punch</h6>
      <h5 className="">{missedCount}</h5>
    </div>
  </div>

</div>

  
}
      

     


      {/* TABLE */}
        <div className="table-responsive attendance-scroll  mt-2">
            <table className="table  text-center attendance-table">
            <thead>
                <tr>
                <th>Date</th>
                <th>Punch In</th>
                <th>Punch Out</th>
                </tr>
            </thead>

            <tbody>
                {loading ? (
                    <tr>
                    <td colSpan="3" className="fw-bold">Loading...</td>
                    </tr>
                ) : filteredData.length > 0 ? (
                    filteredData.map((item, index) => (

                              
                <tr key={index}>
                      <td>{item.pdate}</td>

                      {/* Sunday Leave */}
                      {
                         item.holidays && isCorporate  &&
                              (!item.pintime || item.pintime === "00:00:00") &&
                              (!item.pouttime || item.pouttime === "00:00:00") ? (

                        <td colSpan="2" className="holiday-cell fw-bold" style={{fontSize:".9rem"}}>
                          {item.holidays}
                        </td>

                      )

                      :

                      new Date(item.attDate).getDay() === 0 &&
                      (!item.pintime || item.pintime === "00:00:00") &&
                      (!item.pouttime || item.pouttime === "00:00:00") && isCorporate ? (

                        <td colSpan="2" className="sunday-cell fw-bold" style={{fontSize:".9rem"}}>
                          Sunday
                        </td>

                      ) : isSecondOrFourthSaturday(item.attDate) &&
                          (!item.pintime || item.pintime === "00:00:00") &&
                          (!item.pouttime || item.pouttime === "00:00:00") && isCorporate ? (

                        <td colSpan="2" className="saturday-cell fw-bold" style={{fontSize:".9rem"}}>
                          Saturday
                        </td>

                      ) 

                      : (!item.pintime || item.pintime === "00:00:00") &&
                          (!item.pouttime || item.pouttime === "00:00:00") && isCorporate ? (

                            <td colSpan="3" className="leave-cell fw-bold" style={{fontSize:".9rem"}}>
                              Not Available
                            </td>

                        )

                      

                      //=====================================================================================

                      : (

                        <>
                          <td
                             className={
                               item.holidays
                                        ? "" :
                                  item.pintime >= "12:00:59" &&
                                  item.pintime <= "14:05:00" && isCorporate
                                    ? "half-leave-cell" // First Half Leave
                                    : item.pintime >= "10:32:00" &&
                                      item.pintime < "12:00:59" && isCorporate
                                    ? "permission-cell"
                                    : item.pintime >= "10:06:59" &&
                                      item.pintime <= "10:31:59" && isCorporate
                                    ? "late-cell"
                                    : item.pintime === item.pouttime &&
                                      item.pintime !== "00:00:00" && isCorporate
                                    ? "missed-cell"
                                    : ""
                                }
                              >
                            {item.pintime || "-"}
                          </td>

                          <td
                            className={
                              item.holidays
                                        ? "" :
                                item.pintime !== "00:00:00" &&
                                item.pouttime > "12:00:00" &&
                                item.pouttime < "14:05:00"  && isCorporate
                                  ? "half-leave-cell" // Second Half Leave
                                  : item.pouttime >= "17:00:00" &&
                                    item.pouttime < "18:30:00" && isCorporate
                                  ? "permission-cell"
                                  : item.pouttime > "18:29:59" &&
                                    item.pouttime <= "19:00:00" && isCorporate
                                  ? "late-cell"
                                  : item.pintime === item.pouttime &&
                                    item.pintime !== "00:00:00" && isCorporate
                                  ? "missed-cell"
                                  : ""
                              }
                          >
                            {item.pouttime || "-"}
                          </td>
                        </>
                      )}


                    

                    </tr>

                    ))
                ) : (
                    <tr>
                    <td colSpan="3" className="text-dark fw-bold">
                        No Attendance Data for this date
                    </td>
                    </tr>
                )}
                </tbody>
            </table>
      </div>

    </div>
  );
};

export default Attendance;


// import React, { useState, useEffect } from "react";
// import API from "../axios";
// import "../style/attendance.css"

// const Attendance = () => {
//   const [fromDate, setFromDate] = useState("");
//   const [toDate, setToDate] = useState("");
//   const [data, setData] = useState([]);
//   const [loading, setLoading] = useState(false);

//   const empDetails = JSON.parse(localStorage.getItem("empDetails") || "{}");

//   const isCorporate =
//   empDetails?.branchname?.toLowerCase() === "corporate";

//   // ✅ Set default 26 → 25 cycle
//   useEffect(() => {
//     const today = new Date();

//     let from, to;

//     if (today.getDate() >= 26) {
//       from = new Date(today.getFullYear(), today.getMonth(), 26);
//       to = new Date(today.getFullYear(), today.getMonth() + 1, 25);
//     } else {
//       from = new Date(today.getFullYear(), today.getMonth() - 1, 26);
//       to = new Date(today.getFullYear(), today.getMonth(), 25);
//     }

//     const formatDate = (date) => {
//       const year = date.getFullYear();
//       const month = String(date.getMonth() + 1).padStart(2, "0");
//       const day = String(date.getDate()).padStart(2, "0");
//       return `${year}-${month}-${day}`;
//     };

//     setFromDate(formatDate(from));
//     setToDate(formatDate(to));
//   }, []);

//   // ✅ Fetch Attendance
//   const fetchAttendance = async () => {
//     try {
//       setLoading(true);

//       const res = await API.post("/attendance", {
//         fromDate,
//         toDate,
//         empcode: empDetails.employee_code
//       });

//       console.log(res.data);

//       setData(res.data);
//     } catch (err) {
//       console.error("Error fetching attendance", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // ✅ Auto fetch when date changes (with small delay)
//   useEffect(() => {
//     if (fromDate && toDate) {
//       const delay = setTimeout(() => {
//         fetchAttendance();
//       }, 300);

//       return () => clearTimeout(delay);
//     }
//   }, [fromDate, toDate]);

//   return (
//     <div className="container mt-3">

//       <h4 className="mb-lg-3 mb-4">Attendance</h4>

//       {/* FILTER */}
//       <div className="row mb-lg-3 mb-2 filter-box">
//             <div className="col-6 col-md-2">
//                 <input
//                 type="date"
//                 className="form-control"
//                 value={fromDate}
//                 onChange={(e) => setFromDate(e.target.value)}
//                 />
//             </div>

//             <div className="col-6 col-md-2">
//                 <input
//                 type="date"
//                 className="form-control"
//                 value={toDate}
//                 onChange={(e) => setToDate(e.target.value)}
//                 />
//             </div>
//             </div>

//       {/* TABLE */}
//         <div className="table-responsive attendance-scroll mt-3 mt-lg-0">
//             <table className="table  text-center attendance-table">
//             <thead>
//                 <tr>
//                 <th>Date</th>
//                 <th>Punch In</th>
//                 <th>Punch Out</th>
//                 </tr>
//             </thead>

//               <tbody>
//                   {loading ? (

//                     <tr>
//                       <td colSpan="3" className="fw-bold">
//                         Loading...
//                       </td>
//                     </tr>

//                   ) : data.length > 0 ? (

//                     data.map((item, index) => {

//                       const itemDate = new Date(item.attDate);

//                       // ✅ Sunday Check
//                       const isSunday = itemDate.getDay() === 0;


//                       // ✅ Both zero time
//                       const isZeroTime =
//                         item.pintime === "00:00:00" &&
//                         item.pouttime === "00:00:00";


//                       // ✅ Any punch exists
//                       const hasPunch =
//                         item.pintime !== "00:00:00" ||
//                         item.pouttime !== "00:00:00";

                        

//                       return (

//                         <tr key={index}>

//                           {/* DATE */}
//                           <td>{item.pdate}</td>

//                           {/* ✅ HOLIDAY CONDITION (UNCHANGED) */}
//                           {item.pintime === "00:00:00" &&
//                             item.pouttime === "00:00:00" &&
//                             item.holidays &&
//                             isCorporate ? (

//                               <td
//                                 colSpan="2"
//                                 className="fw-bold text-dark"
//                                 style={{
//                                   backgroundColor: "#D5EDDB ",
//                                   borderRadius: "6px"
//                                 }}
//                               >
//                                 {item.holidays}
//                               </td>

//                           ) : 

//                           /* ✅ SUNDAY CONDITION */
//                           isSunday && isZeroTime ? (

//                             <td
//                               colSpan="2"
//                               className="fw-bold text-dark sundayBg"
//                               style={{
//                                 borderRadius: "6px"
//                               }}
//                             >
//                               Sunday
//                             </td>

//                           ) : (

//                             <>
//                               {/* <td
//                                 className={hasPunch ? "punchBg" : ""}
//                               >
//                                 {item.pintime || "-"}
//                               </td>

//                               <td
//                                 className={hasPunch ? "punchBg" : ""}
//                               >
//                                 {item.pouttime || "-"}
//                               </td> */}
//                               <td
//                                   className={
//                                     hasPunch
//                                       ? isSunday
//                                         ? "extraDutyBg"
//                                         : "punchBg"
//                                       : ""
//                                   }
//                                 >
//                                   {item.pintime || "-"}
//                                 </td>

//                                 <td
//                                   className={
//                                     hasPunch
//                                       ? isSunday
//                                         ? "extraDutyBg"
//                                         : "punchBg"
//                                       : ""
//                                   }
//                                 >
//                                   {item.pouttime || "-"}
//                                 </td>

//                             </>

//                           )}

//                         </tr>
//                       );
//                     })

//                   ) : (

//                     <tr>
//                       <td colSpan="3" className="text-dark fw-bold">
//                         No Data Found
//                       </td>
//                     </tr>

//                   )}
//                 </tbody>
//             </table>
//       </div>

//     </div>
//   );
// };

// export default Attendance;
